exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sort-img[data-v-0c81d810]{display:grid;grid-template-columns:repeat(auto-fill, 80px);gap:5px}.sort-img-item[data-v-0c81d810]{width:80px;height:80px;padding:2px;border-radius:5px;position:relative;border:1px solid #c0c4cc}.sort-img-item-image[data-v-0c81d810]{width:100%;height:100%}.sort-img-item .btndel[data-v-0c81d810]{position:absolute;right:-4px;top:-4px;font-size:16px;color:#f01;cursor:pointer;background:#fff;border-radius:50%}", ""]);

// exports
